import * as geolib from 'geolib';

/**
 * Creates a LineString geoJSON with extra arrays 'bearings' and mileMarkers' with points equally spaced every distBetweenPoints
 * @param routeGeoJSON The original LineString geoJSON
 * @param desiredDistanceBetweenPoints The desired distance between points (miles), likely equal to 0.01 miles
 * @returns {{type: string}} LineString geoJSON with extra arrays 'bearings' and mileMarkers' with points equally spaced
 */
export function findEquidistantPointsAlongRoute(routeGeoJSON, desiredDistanceBetweenPoints = 0.01) {
  var finalCoordinates = [];
  var bearings = [];
  var mileMarkers = [];
  var start_mm = 0.0;
  var remaining_distance_miles = 0;

  for (var i = 0; i < routeGeoJSON.coordinates.length - 1; i++) {
    var start = routeGeoJSON.coordinates[i];
    finalCoordinates.push(start);
    var end = routeGeoJSON.coordinates[i + 1];

    var total_distance = geolib.getDistance(start, end);
    var total_distance_miles = total_distance * 0.00062137;

    var total_actual_distance_miles = total_distance_miles + remaining_distance_miles;

    var num_points_mid = Math.floor(total_actual_distance_miles / desiredDistanceBetweenPoints);

    var distance = desiredDistanceBetweenPoints * 1609.34; // every 0.01 miles move marker

    var temp_start = start;

    if (num_points_mid > 0) {

      for (var z = 0; z < num_points_mid; z++) {
        let bearing = geolib.getGreatCircleBearing(temp_start, end)
        let coord = geolib.computeDestinationPoint(temp_start, distance - (remaining_distance_miles * 1609.34), bearing)
        finalCoordinates.push([coord.longitude, coord.latitude]);
        temp_start = [coord.longitude, coord.latitude];
        remaining_distance_miles = 0;
      }
    }
    remaining_distance_miles = total_actual_distance_miles - num_points_mid * desiredDistanceBetweenPoints;
  }

  finalCoordinates.push(routeGeoJSON.coordinates[routeGeoJSON.coordinates.length - 1]);
  let mm_count = 0.00;

  for (var i = 0; i < finalCoordinates.length - 1; i++) {
    bearings.push(geolib.getGreatCircleBearing(finalCoordinates[i], finalCoordinates[i + 1]))
    let dist = geolib.getDistance(finalCoordinates[i], finalCoordinates[i + 1]);
    mm_count += dist;
    mileMarkers.push(mm_count * 0.000621371);
    // mm_count += desiredDistanceBetweenPoints;
  }
  bearings.push(geolib.getGreatCircleBearing(finalCoordinates[finalCoordinates.length - 2], finalCoordinates[finalCoordinates.length - 1]))
  mileMarkers.push((mm_count + remaining_distance_miles - desiredDistanceBetweenPoints) * 0.000621371);
  //this is the final modified geoJSON that contains linear referenced coordinates on the route at 0.01 mile frequency
  var equidistantGeoJSON = {type: 'LineString'};
  //assigning final set of coordinates to geoJSON
  equidistantGeoJSON.coordinates = finalCoordinates;
  //adding bearings for each coordinate
  equidistantGeoJSON.bearings = bearings;
  //adding a mile marker reference for each coordinate
  equidistantGeoJSON.mileMarkers = mileMarkers;
  return equidistantGeoJSON;
}

/**
 * Split the route into multiple routes of <splitLength> length
 * @param geoJson The original route to be split
 * @param splitLength How often to split the route (miles)
 * @returns {[]} An array of new, shorter routes
 */
export function splitRoute(geoJson, splitLength) {
  let routes = []

  // Temporary arrays to fill
  let coordinates = []
  let mileMarkers = []
  let bearings = []

  for (let i = 0; i < geoJson.coordinates.length; i++) {
    // Add the point to the lists
    coordinates.push(geoJson.coordinates[i])
    mileMarkers.push(geoJson.mileMarkers[i])
    bearings.push(geoJson.bearings[i])
    // If this mile marker is divisible by our split (toFixed is for floating point imprecision),
    // then add what we've collected already to the list of routes and reset
    if ((geoJson.mileMarkers[i].toFixed(2) % splitLength === 0 && i !== 0) || geoJson.coordinates.length - 1 === i) {
      // Push a copy of the new sub-route
      routes.push({
        type: "LineString",
        coordinates: coordinates,
        mileMarkers: mileMarkers,
        bearings: bearings
      });
      coordinates = []
      mileMarkers = []
      bearings = []
    }
  }
  return routes.filter(route => route.coordinates.length > 1);
}
